import { render, staticRenderFns } from "./TimelineTip.vue?vue&type=template&id=2347463e&"
import script from "./TimelineTip.vue?vue&type=script&lang=js&"
export * from "./TimelineTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports